import type { ConfigStoryblok } from '#core/storyblok-component-types'

export const useConfig = () => {
  const headers = useHeaderContent()
  const footer = useFooterContent()

  function fetchConfig() {
    return $fetch<ConfigStoryblok>('/api/settings')
  }

  async function setConfig() {
    const data = await fetchConfig()

    if (!data) {
      return
    }

    headers.value = {
      default: data?.content.header,
      pro: data?.content.proHeader,
      joinUnbiased: data?.content.joinUnbiased,
      sharedHeaderLinks: data?.content.sharedHeaderLinks,
    }
    footer.value = {
      default: data?.content.footer,
      pro: data?.content.proFooter,
      legalCopy: data?.content.legalCopy,
    }
  }

  return {
    setConfig,
  }
}
